const flattenErrors = (errors, parentKey = "") => {
  let flatErrors = {};
  for (const key in errors) {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    if (typeof errors[key] === "object" && errors[key] !== null) {
      Object.assign(flatErrors, flattenErrors(errors[key], newKey));
    } else {
      flatErrors[newKey] = errors[key];
    }
  }
  return flatErrors;
};

const scrollToFirstError = (errors) => {
  const flatErrors = flattenErrors(errors);
  let firstErrorElement = null;
  let firstErrorPosition = Infinity;

  for (const key in flatErrors) {
    const errorElement = document.querySelector(`[name="${key}"]`);
    if (errorElement) {
      const position = errorElement.getBoundingClientRect().top;
      if (position < firstErrorPosition) {
        firstErrorPosition = position;
        firstErrorElement = errorElement;
      }
    }
  }

  if (firstErrorElement) {
    firstErrorElement.scrollIntoView({ behavior: "smooth" });
    // delay the focus to ensure the element is in view. Otherwise scroll is unsmooth
    setTimeout(() => {
      firstErrorElement.focus();
    }, 1000);
  }
};

export default scrollToFirstError;
